import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "../ui/button";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-white">

      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-white to-purple-50"></div>

      {/* Glow Effects */}
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-indigo-400/20 rounded-full blur-[120px]" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-purple-400/20 rounded-full blur-[120px]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-24">
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* LEFT SIDE */}
          <div className="space-y-8">

            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 px-4 py-2 rounded-full text-sm font-medium">
              <Sparkles size={16} />
              Enterprise Digital Transformation
            </div>

            {/* Heading */}
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
              Re(AI)define
              <span className="block bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mt-2">
                The Future
              </span>
            </h1>

            {/* Description */}
            <p className="text-xl text-gray-600 max-w-xl leading-relaxed">
              Enable scalable growth with AI-driven, cloud-enabled and digitally
              engineered platforms. Partner with TECHSPR to accelerate innovation
              and transformation.
            </p>

            {/* Buttons */}
            <div className="flex flex-wrap gap-4">

              <Button
                asChild
                size="lg"
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-6 rounded-xl shadow-lg hover:shadow-xl transition-all group"
              >
                <Link to="/services" className="flex items-center gap-2">
                  Explore Services
                  <ArrowRight className="group-hover:translate-x-1 transition" size={18} />
                </Link>
              </Button>

              <Button
                asChild
                size="lg"
                variant="outline"
                className="px-8 py-6 rounded-xl border-2 border-gray-300 hover:border-indigo-600 hover:text-indigo-600 transition"
              >
                <Link to="/contact">Contact Us</Link>
              </Button>

            </div>

            {/* Stats */}
            <div className="flex gap-10 pt-6">

              <div>
                <h3 className="text-3xl font-bold text-gray-900">40+</h3>
                <p className="text-gray-600 text-sm">Projects Delivered</p>
              </div>

              <div>
                <h3 className="text-3xl font-bold text-gray-900">10+</h3>
                <p className="text-gray-600 text-sm">Industries</p>
              </div>

              <div>
                <h3 className="text-3xl font-bold text-gray-900">99%</h3>
                <p className="text-gray-600 text-sm">Client Satisfaction</p>
              </div>

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="relative hidden lg:block">

            {/* Main Gradient Card */}
            <div className="absolute inset-0 flex items-center justify-center ">
              <div className="w-72 h-72 rounded-3xl bg-gradient-to-br from-indigo-600 to-purple-600 blur-2xl opacity-60"></div>
            </div>

            {/* Glass Cards */}
            <div className="relative space-y-6 flex flex-col items-center justify-center">

              {/* Purple Glow Background */}
              <div className="absolute w-[420px] h-[420px] bg-gradient-to-r from-indigo-500 via-purple-500 to-indigo-400 blur-3xl opacity-40 rounded-full"></div>

              <div className="relative w-[520px] h-[420px]">

                {/* Girl Image */}
                <img
                  src="https://foundlocalmarketing.com/wp-content/uploads/2025/04/photo-girl-with-laptop-sit-bean-bag-raise-thumb-up-purple-background-1.webp"
                  alt="girl"
                  className="absolute right-0 top-0 w-[480px] scale-x-[-1]"
                />

              {/* Card 1 - Laptop ke upar */}
                <div className="absolute top-[-30px] right-[260px] bg-white/80 backdrop-blur-xl shadow-xl rounded-xl p-4 w-52 transition hover:-translate-y-2 float-animation">
                  <div className="flex gap-2 mb-3">
                    <div className="w-2.5 h-2.5 bg-green-500 rounded-full"></div>
                    <div className="w-2.5 h-2.5 bg-yellow-500 rounded-full"></div>
                    <div className="w-2.5 h-2.5 bg-red-500 rounded-full"></div>
                  </div>

                  <div className="space-y-1">
                    <div className="h-2 bg-gray-200 rounded"></div>
                    <div className="h-2 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-2 bg-gray-200 rounded w-4/6"></div>
                  </div>
                </div>

                {/* Card 2 - Shoes ke paas */}
                <div className="absolute bottom-[180px] right-[360px] bg-white/80 backdrop-blur-xl shadow-xl rounded-xl p-4 w-52 transition hover:-translate-y-2 float-animation">
                  <img
                    src="/images/team.jpg"
                    alt="card"
                    className="w-full rounded-lg"
                  />
                </div>

                {/* Card 3 - Bottom Right */}
                <div className="absolute bottom-[20px] right-[-120px] bg-white/80 backdrop-blur-xl shadow-xl rounded-xl p-4 w-48 transition hover:-translate-y-2 transition float-animation">
                  <div className="flex items-center gap-3">
                    <img
                      src="/images/technology.png"
                      alt="card"
                      className="w-full rounded-lg"
                    />

                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>
      </div>
    </section>
  );
};



export default Hero;